import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LandingHeader from "../../components/LandingHeader/Header";
import LandingFooter from "../../components/footer/LandingFooter";
import { contentContext } from "../../context/contentContext";

const ProductionHub = () => {
    const [config, setConfig] = useState({});
    const { menus, setContentSearchFlag, inactiveFlag, setInactiveFlag, contentSearchFlag, clientData, setClientData, setRoute } = useContext(contentContext);
    const navigate = useNavigate();
    let img = window.app.img;
    useEffect(() => {
        if (window.site) {
            setConfig(window.site);

        }

    }, [window.site]);



    if (config.common && config.common.imagesCDN) {
        img = config.common.imagesCDN;
    }
    const handleAll = () => {
        navigate("/faq");
        window.scrollTo(0, 0);
    }

    return (
        <>
            <LandingHeader />

            <section className="production-hero-section ">
                <div className="production-hero-bg">
                    <img src={`${img}orasi/client/resources/orasiv1/images/f6da0913b6ca7aa036c7825ebecec69dc44ec127.png`} alt="Background"
                        className="production-bg-img" />
                </div>

                <div className="container-fluid production-hero-container">
                    <div className="production-hero-content d-flex flex-column align-items-center text-center">
                        <div className="production-hero-text-wrapper">
                            <p className="production-hero-subtitle" data-aos="fade-up" data-aos-duration="1000">Production Circle</p>
                            <h1 className="production-hero-title" data-aos="fade-up" data-aos-duration="1400">One hub. Zero chaos.</h1>
                            <p className="production-hero-description" data-aos="fade-up" data-aos-duration="1800">
                                From script to screen, Orasi’s Production Circle keeps your entire team aligned, helping you plan,
                                budget, and collaborate up to 70% faster.
                            </p>
                        </div>

                        <a
                            className="custom-btn-primary "
                            data-aos="fade-up"
                            data-aos-duration="2200"
                            href="http://app.orasimedia.com/checkout"
                            target="_blank"
                            rel="noopener noreferrer" // safe for external links
                        >
                            Start Planning Smarter
                            <span className="material-icons">north_east</span>
                        </a>

                    </div>
                </div>
            </section>

            <section className="challenge-solution-section ">
                <div className="container-fluid challenge-solution-container">
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="challenge-solution-card" data-aos="fade-up" data-aos-duration="1000">
                                <div className="card-header-icon" >
                                    <span className="material-symbols-outlined">target</span>
                                    <h3>The Challenge</h3>
                                </div>
                                <p >Filmmakers still juggle Excel, Celtx, email threads, and endless versions. The result? Lost
                                    time, blown budgets, constant stress.</p>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="challenge-solution-card" data-aos="fade-up" data-aos-duration="1400">
                                <div className="card-header-icon">
                                    <span className="material-symbols-outlined">star</span>
                                    <h3>The Solution</h3>
                                </div>
                                <p>With Orasi's Production Circle, everything lives in one ecosystem. Real-time updates, integrated
                                    tools, and seamless collaboration ensure production headaches never derail your story.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="production-features-section ">
                <div className="container-fluid production-features-container">
                    <div className="features-header" data-aos="fade-up" data-aos-duration="1000">
                        <h2>Made to scale</h2>
                    </div>

                    <div className="features-grid">
                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1000">
                            <div className="feature-image" >
                                <img src={`${img}orasi/client/resources/orasiv1/images/6ed298bfc7ce1037fe27837a50df6dcb329ab036.png`} alt="Real-Time Budgets" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4 >Real-Time Budgets</h4>
                                <p >Track costs instantly, no surprises.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1400">
                            <div className="feature-image" >
                                <img src={`${img}orasi/client/resources/orasiv1/images/57e7821a51688675e48d583d65fcf66b461c8941.png`} alt="AI Assistance" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4 >AI Assistance</h4>
                                <p >Use automation to speed up scheduling and task management.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1800">
                            <div className="feature-image" >
                                <img src={`${img}orasi/client/resources/orasiv1/images/a49e15e79c1a4e26037a64bbc38fe57d875bc737.png`} alt="Tool Integrations" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4 >Tool Integrations</h4>
                                <p>Connect with Final Draft, Google Maps, CSV/PDF export.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="2200">
                            <div className="feature-image" >
                                <img src={`${img}orasi/client/resources/orasiv1/images/c759b09cc1d82572b91fb1f700cc78b527204a21.png`} alt="Storyboard in Seconds" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4 >Storyboard in Seconds</h4>
                                <p >Visualize scripts into clear shot lists.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="target-audience-section ">
                <div className="container-fluid target-audience-container">
                    <div className="target-audience-card" data-aos="fade-up" data-aos-duration="1000">
                        <div className="row g-0">
                            <div className="col-lg-6">
                                <div className="target-section" >
                                    <h3>Who is this for?</h3>
                                    <div className="target-list">
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Indie teams looking for fast, low-cost production management.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Studios managing multi-location shoots and large crews.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Co-productions across countries and languages.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="target-section">
                                    <h3>By the number</h3>
                                    <div className="target-list">
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>Producers cut up to 70% of planning time.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>Thousands of film teams already using Orasi-powered tools.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>One hub replaces 5+ disconnected apps.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="production-cta-section ">
                <div className="production-cta-bg"></div>

                <div className="container production-cta-container">
                    <div className="production-cta-content d-flex align-items-center gap-2 justify-content-center flex-column text-center">
                        <p className="cta-subtitle" data-aos="fade-up" data-aos-duration="1000">Get Started</p>
                        <h2 className="cta-title" data-aos="fade-up" data-aos-duration="1400">
                            Ready to replace spreadsheets with <br className="d-none d-md-block" />
                            storytelling?
                        </h2>

                        {/* <button className="custom-btn-primary" data-aos="fade-up" data-aos-duration="1800" href="http://app.orasimedia.com/checkout" target="_blank">
                            Start for Free
                            <span className="material-icons">arrow_forward</span>
                        </button> */}
                        <a
                            className="custom-btn-primary "
                            data-aos="fade-up"
                            data-aos-duration="2200"
                            href="http://app.orasimedia.com/checkout"
                            target="_blank"
                            rel="noopener noreferrer" // safe for external links
                        >
                            Start for Free
                            <span className="material-icons">arrow_forward</span>
                        </a>
                    </div>
                </div>
            </section>

            <section className="faq-section">
                <div className="container-fluid faq-container">
                    <div className="faq-header">
                        <h2>Frequently Asked Questions</h2>
                    </div>

                    <div className="faq-list" id="faqAccordion">

                        {/* FAQ 1 */}
                        <div className="faq-item">
                            <div
                                className="faq-question"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq1"
                            >
                                <h4>What is The Production Circle?</h4>
                                <span className="material-icons faq-icon">expand_less</span>
                            </div>

                            <div
                                id="faq1"
                                className="collapse show"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="faq-answer">
                                    <p>
                                        The Production Circle is an all-in-one collaboration platform for
                                        producers, directors, writers, and other stakeholders to manage
                                        every phase of production. It includes scriptwriting, storyboarding,
                                        character development, budgeting, scheduling, scene planning, and
                                        more—powered by AI-assisted tools, which can be turned on/off as per your discretion.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 2 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq2"
                            >
                                <h4>How do I sign up?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>

                            <div id="faq2" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        Enter your email to create a free account. You will receive a verification
                                        email to confirm your address and set a password.After completing these steps,
                                        you can access The Production Circle dashboard.


                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 3 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq3"
                            >
                                <h4>How does it work?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>

                            <div id="faq3" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        Once logged in, your dashboard provides access to tools such as scriptwriting,
                                        team collaboration, task management, moodboards, storyboards, budgeting, casting,
                                        production assistance, and more.

                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 4 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq4"
                            >
                                <h4>Can I add collaborators?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>
                            <div id="faq4" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        Yes. You can invite team members to collaborate on projects and share
                                        documents, files, media, and tasks with them.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 5 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq5"
                            >
                                <h4>Who is The Production Circle for?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>
                            <div id="faq5" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        It is designed for anyone involved in content creation—including producers,
                                        directors, writers, production executives, and other project stakeholders.

                                    </p>
                                </div>
                            </div>
                        </div>

                      
                        <div className="d-flex justify-content-end align-items-center">
                            <a className="anchor-txt" onClick={handleAll}>View All<span className="material-icons">chevron_right</span></a>
                        </div>
                    </div>
                </div>
            </section>

            {/* <section className="faq-section">
        <div className="container-fluid faq-container">
            <div className="faq-header">
                <h2>Frequently asked questions</h2>
            </div>

            <div className="faq-list">
        
                <div className="faq-item expanded">
                    <div className="faq-question" data-bs-toggle="collapse" data-bs-target="#faq1">
                        <h4>Qui aliquip occaecat et laborum?</h4>
                        <span className="material-icons faq-icon">expand_less</span>
                    </div>
                    <div className="collapse show" id="faq1">
                        <div className="faq-answer">
                            <p>Consectetur id aliqua cillum dolore eu ipsum. Anim nisi dolore ipsum non dolore dolor
                                voluptate veniam ea id ipsum Lorem. Dolore pariatur sunt mollit laborum pariatur fugiat
                                mollit sint ut ullamco laborum. Occaecat commodo laborum esse ut veniam ipsum enim id
                                nostrud anim nostrud labore. Commodo esse exercitation aute irure id culpa pariatur in
                                id cupidatat minim incididunt ex est aliqua.</p>
                        </div>
                    </div>
                </div>

             
                <div className="faq-item">
                    <div className="faq-question" data-bs-toggle="collapse" data-bs-target="#faq2">
                        <h4>Qui sunt ex non ex non voluptate occaecat et ut laborum aliquip?</h4>
                        <span className="material-icons faq-icon">chevron_right</span>
                    </div>
                    <div className="collapse" id="faq2">
                        <div className="faq-answer">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        </div>
                    </div>
                </div>

                <div className="faq-item">
                    <div className="faq-question" data-bs-toggle="collapse" data-bs-target="#faq3">
                        <h4>In in amet labore qui ullamco magna anim excepteur non occaecat irure?</h4>
                        <span className="material-icons faq-icon">chevron_right</span>
                    </div>
                    <div className="collapse" id="faq3">
                        <div className="faq-answer">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        </div>
                    </div>
                </div>

                <div className="faq-item">
                    <div className="faq-question" data-bs-toggle="collapse" data-bs-target="#faq4">
                        <h4>In nulla commodo sint?</h4>
                        <span className="material-icons faq-icon">chevron_right</span>
                    </div>
                    <div className="collapse" id="faq4">
                        <div className="faq-answer">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> */}
            <LandingFooter menus={menus} />
        </>
    );
};

export default ProductionHub;
